<template>
    <modal @close="$emit('close')" :open="localOpen" size="lg">
        <template #header>
            Subscribe to our Newsletter
        </template>
        <template #default>
            <form @submit.prevent="processForm" id="newsletter-subscription-form">
                <container>
                    <row>
                        <column :md="12">
                            <form-group :valid="firstNameValid">
                                <form-label>First Name:</form-label>
                                <form-input name="first-name" v-model="firstName" @input="validateForm" />
                            </form-group>
                        </column>

                        <column :md="12">
                            <form-group :valid="lastNameValid">
                                <form-label>Last Name:</form-label>
                                <form-input name="last-name" v-model="lastName" @input="validateForm" />
                            </form-group>
                        </column>

                        <column :md="12">
                            <form-group :valid="emailValid">
                                <form-label>Email:</form-label>
                                <form-input name="email" type="email" v-model="email" @input="validateForm" />
                            </form-group>
                        </column>

                        <column :md="12">
                            <form-group :valid="newslettersValid">
                                <form-label>Select Newsletters:</form-label>
                                <static-multi-select :options="newsletterOptions" v-model="newsletters" placeholder="Select Newsletters" @input="validateForm" />
                            </form-group>
                        </column>
                    </row>
                </container>
            </form>

            <bot-challenge v-if="showChallenge" @verify="verifyHuman" @close="showChallenge=false" />

        </template>
        <template #buttons>
            <ui-button color="secondary" @click="localOpen=false" :underline="true" class="order-2 order-md-1" block="sm">
                Cancel
            </ui-button>
            <ui-button :submit="true" form="newsletter-subscription-form" class="order-1 order-md-2 mb-3 mb-md-0" block="sm">
                Submit
            </ui-button>
        </template>
    </modal>
</template>

<script type="text/javascript">
    import BotChallenge from '@/components/Content/Auth/BotsChallenge.vue'; 
    import CommonComponents from '@/components/Common.vue';

    import Api from '@/classes/Api.js';
    import ReCaptcha from '@/classes/Google/ReCaptcha.js';
    import FormOption from '@/classes/FormOption.js';
    import Analytics from '@/classes/Analytics.js';
    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            BotChallenge,
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                showChallenge: false,
                botKey: null,
                botVerified: false,

                localOpen: true,
                buttonsLoading: false,
                newsletterOptions: FormOption.fromList('Renter', 'Owner', 'Broker', 'Travel Agent', 'Prospective Buyer', 'Investor', 'Industry Partner', 'Local Business/Vendor'),

                firstName: null,
                lastName: null,
                email: null,
                newsletters: ['Renter', 'Owner', 'Broker', 'Travel Agent', 'Prospective Buyer', 'Investor', 'Industry Partner', 'Local Business/Vendor'],

                startValidation: false,
                firstNameValid: null,
                lastNameValid: null,
                emailValid: null,
                newslettersValid: null,
            };
        },

        props: {
            open: {
                type: Boolean,
                default: true,
            },
        },

        emits: ['close', 'save'],

        created() {
            this.localOpen = this.open;
        },

        watch: {
            open(newVal) {
                this.localOpen = newVal;
            }
        },

        methods: {
            validateForm() {
                if (!this.startValidation) return;

                let valid = true;
                this.firstNameValid = null;
                this.lastNameValid = null;
                this.emailValid = null;
                this.newslettersValid = null;

                if (!this.firstName) {
                    valid = false;
                    this.firstNameValid = false;
                }
                if (!this.lastName) {
                    valid = false;
                    this.lastNameValid = false;
                }
                if (!this.email) {
                    valid = false;
                    this.emailValid = false;
                }
                if ((!this.newsletters) || (this.newsletters.length == 0)) {
                    valid = false;
                    this.newslettersValid = false;
                }

                return valid;
            },

            async processForm() {
                this.startValidation = true;
                if (!this.validateForm()) {
                    this.uiStore.toast({
                        error: true,
                        title: 'Required Fields',
                        message: 'Please complete the required highlighted fields',
                    });

                    return;
                }

                this.buttonsLoading = true;

                let token = await ReCaptcha.submit();

                let data = {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    email: this.email,
                    newsletters: [...this.newsletters],
                    recaptchaToken: token,
                };

                if (this.botVerified) {
                    data.botChallenge = this.botKey;
                }
                
                let response = await Api.post('leads/newsletter', data);

                if ((response.valid) && (response.results) && (!response.results.error)) {

                    Analytics.event('Lead', {
                        content_category: 'newsletter',
                    });
                    
                    this.uiStore.toast({
                        success: true,
                        title: 'Thank You',
                        message: 'Thank you for subscribing to our newsletter',
                    });
                    this.localOpen = false;
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {

                        if (response.results.error.message) {
                            error = response.results.error.message;
                        }
                        else if (response.results.error.botChallenge) {
                            error = null;
                            this.botVerified = false;
                            this.botKey = response.results.error.botChallenge;
                            this.showChallenge = true;
                        }
                        else {
                            error = response.results.error;
                        }
                    }

                    if (error) {
                    
                        this.uiStore.toast({
                            error: true,
                            title: 'Error',
                            message: error,
                        });
                    }
                }

                this.buttonsLoading = false;

            },

            verifyHuman() {
                this.botVerified = true;

                this.processForm();
            },
        },

    };

</script>
